<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">よくあるご質問</h1>

      <section>
        <v-expansion-panel focusable>
          <v-expansion-panel-content v-for="item in faq" :key="item.title">
            <div slot="header">
              <h3 class="subheading">{{ item.title }}</h3>
            </div>
            <v-card>
              <v-card-text class="grey lighten-3">
                {{ item.answer }}
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </section>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  name: 'Faq',
  data () {
    return {
      faq: [
        { title: 'ID、パスワードを忘れてしまったのですが、どうすれば良いですか？', answer: '「お問い合わせ」から、挙式日、会場名、ご新郎ご新婦さまのフルネーム記載の上、その旨ご連絡下さい。' },
        { title: 'メールアドレスを変更したいのですが、どうすれば良いですか？', answer: 'マイページのお客様情報より、変更いただけます。' },
        { title: '初期登録画面にて、挙式日を間違って入力してしまいました。どうすれば良いですか？', answer: '「お問い合わせ」から、お客様ID、会場名、ご新郎ご新婦さまのフルネーム、正しい挙式日を記載の上、その旨ご連絡下さい。' },
        { title: '曲リストを作成している途中なのですが、現状の状態を保存するにはどうすれば良いですか？', answer: '情報は常に最新のものに自動更新されておりますので、ログアウトする際なども、保存する必要はございません。' },
        { title: '進行プレイリストは、何シーンまで増やせますか？', answer: '最大２５シーンまでご利用できます。' },
        { title: '歓談プレイリストは、何曲、決められますか？', answer: '１０曲固定となりますので、漏れなくお選び下さい。' },
        { title: '歓談プレイリストは、どのようなシーンで使用しますか？', answer: '歓談、迎賓、送賓、テーブルラウンド、中座中、デザートビュッフェ、プロフィール紹介などで使用致します。また、進行プレイリストでお選びになった曲が終わってしまった際などに、補助的に使用する場合もございます。' },
        { title: 'おすすめプレイリストを、そのまま自分たちのプレイリストへ反映する事は出来ますか？', answer: 'お好みのプレイリストが見つかったら「プレイリストに適用」ボタンを押していただく事により、進行プレイリスト、歓談プレイリストのいずれかに適用する事が出来ます。その際、現状セットされている曲目を上書きして置き換えますので、適用の際は慎重に願います。' },
        { title: 'シーン別検索で表示される曲以外にも、その該当シーンに曲を使用する事は出来ますか？', answer: 'システム内にある全ての曲、どのシーンにもセットする事が出来ます。シーン別検索で表示される曲に関しては、シーン意図に合致したおすすめの曲となります。' },
        { title: 'いつまでに「プレイリスト決定」をすれば良いですか？', answer: 'プレイリストのページにて、締切日が記載されておりますので、そちらをご確認下さい。' },
        { title: 'プレイリストが未決定の状態で、締切日を過ぎてしまった場合はどうなりますか？', answer: 'プレイリストが自動的にロックされますので、ご新郎ご新婦さまにおかれましてはプレイリストの変更が出来なくなります。その際、会場お任せという形で、各シーンに準じた選曲をさせていただきますので予めご了承下さい。' },
        { title: '間違って「プレイリスト決定」を押してしまったのですが、キャンセルは出来ますか？', answer: '会場担当プランナー、または音響担当者までお問い合わせ下さい。オペレートの都合上、挙式日が迫るものに関しましては、ご対応が難しい場合もございますので、プレイリストの決定は慎重にお願い致します。' },
        { title: '曲を視聴していると定期的にウィズムという音声が入っているのですが、挙式当日に流れる際、この音声は外れますか？', answer: '複製防止を目的とした音声（ウォーターマーク）となります。挙式当日に流れる際は、この音声は外れますのでご安心下さい。' },
        { title: '曲データをダウンロードする事は出来ますか？', answer: 'ご新郎ご新婦さまに関しましては、曲データのダウンロードは出来ない仕様とさせていただいております。ご購入をご希望のお客様は、各アーティストのHPをご確認していただき、そちらへお問い合わせ下さい。' },
        { title: '複数のプレイリストを作成する事は可能ですか？', answer: '作成できるプレイリストは、進行プレイリスト１つ、歓談プレイリスト１つとなります。' },
        { title: '挙式中の曲を決める事は出来ますか？', answer: 'ウィズムは、挙式後のイベントシーンからを意図した曲の取り扱いとなっております。詳しくは、会場担当プランナー、または音響担当者までお問い合わせ下さい。' },
        { title: '余興にウィズムの曲を使用する事は出来ますか？', answer: '会場の雰囲気作りなど余興のBGMとして流す事は可能ですが、ビデオレターなどの映像演出に、ウィズムの曲を使用する事は出来ません。詳しくは、会場担当プランナー、または音響担当者までお問い合わせ下さい。' },
        { title: 'テーブルラウンドのイベントに複数曲使いたいのですが、どうすれば良いですか？', answer: 'シーンを追加にて「各卓イベント」をお選びいただき、時系列に沿ってイベントの並び替えをお願いします。その際、各卓イベントは３曲を目処にお選び下さい。進行の進み具合によっては、全ての曲を使い切らない場合もございますので予めご了承下さい。' },
        { title: '「シーンを追加」に無いイベントは、どのように追加すれば良いですか？', answer: 'シーン選択にて「その他」をお選びいただき、「コメント編集」にイベント名と詳細をご記入下さい。' },
        { title: '曲を途中から使いたいのですが、秒数指定は出来ますか？', answer: '使用箇所に希望がある場合は、プレイリストに曲をセットした後「コメント編集」にて記入をお願い致します。また進行オペレートの都合上、ご希望に添えない場合もございますので、予めご了承下さい。例：ケーキ入刀は、1:26のサビから再生をお願いします。' },
        { title: '歌詞を確認する事は出来ますか？', answer: '曲項目の右端にある「リストマーク」が緑色のものは、クリックする事で歌詞を表示する事が出来ます。' },
        { title: 'オープニングやプロフィールムービー、エンドロールのような演出映像の曲はどうすれば良いですか？', answer: '演出映像に関しましては、制作期間の兼ね合いにて、基本的にプレイリストへの組み入れが出来ません。制作手順や納期に関しましては、別途、確認が必要となりますのでご注意下さい。詳しくは、会場担当プランナー、または映像担当者までお問い合わせ下さい。' },
        { title: '自分たちの披露宴の進行順番がよく分かりません。プレイリストの順番は、どのように組み立てれば良いでしょうか？', answer: '会場担当プランナーまでお問い合わせ下さい。' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Faq.vue